// Import package from Soil plugin example.
import $ from "@modules/jquery";

$(function () {
  const urlParams = new URLSearchParams(window.location.search);
  const keuze = urlParams.get("keuze");
  if (keuze) {
    const $form = $("#contact-form");
    if ($form.length) {
      const extraOffset = -150;
      $("html, body").animate(
        { scrollTop: $form.offset().top + extraOffset },
        50
      );
    }
  }
});
